import { Box, Button, IconButton, Typography } from "@mui/material";
import React, { Component } from "react";
import creashScreen from "../../images/phase-3/CrashScreen/crash_screen.png"; // Adjust the path as necessary
import { Info } from "@mui/icons-material";
import { CiCircleInfo } from "react-icons/ci";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught an error", error, errorInfo);
  }

  handleDismiss = () => {
    this.setState({ hasError: false });
    window.location = "/";
    // this.props.history.push('/')
  };

  render() {
    if (this.state.hasError) {
      return (
        <Box style={styles.container}>
          <Box style={styles.messageBox}>
            <Box display={"flex"} alignItems="center" gap={1}>
              <IconButton color="error">
                <CiCircleInfo style={{ fontSize: "40px" }} />
              </IconButton>
              <Typography
                variant="body2"
                style={{
                  textAlign: "left",
                  fontSize: "20px",
                  fontWeight: 600,
                }}
              >
                Sorry, Something Went Wrong.
              </Typography>
            </Box>
            <img
              src={creashScreen}
              alt="crash-screen"
              style={{ width: "300px", margin: "auto" }}
            />
            <Typography
              variant="body2"
              style={{ width: "700px", margin: "auto", fontSize: "16px" }}
            >
              This page will automatically reload in few seconds. Please do
              check your internet connection, if the problem still persists.
            </Typography>
            <Button
              onClick={this.handleDismiss}
              variant="contained"
              style={{ marginTop: "20px" }}
            >
              Reload Now
            </Button>
          </Box>
        </Box>
      );
    }

    return this.props.children;
  }
}

const styles = {
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    backgroundColor: "#FCFCFC", // Light blue background
    // color: "#00796b", // Darker blue-green text
    fontFamily: "Arial, sans-serif",
  },
  messageBox: {
    width: "50%",
    textAlign: "center",
    padding: "20px",
    borderRadius: "8px",
    backgroundColor: "#ffffff", // White background for the message box
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", // Light shadow for subtle depth
  },
};

export default ErrorBoundary;
